<template>
  <div>
    <q-dialog :visible="isVisible" :title="title" width="600px" :innerScroll="false" :showFooter="false" @close="onCancel">
      <div class="content">
        <div class="header-right">
          <el-button type="primary" size="mini" @click="add">新增</el-button>
        </div>
        <el-table :data="tableData.records" border height="380" style="width: 100%" ref="myTable" v-loading="loading">
          <el-table-column prop="classificationName" label="限售分类名称" align="center">
            <template slot-scope="{ row }">
              <el-input v-model="row.classificationName" size="mini" maxlength="20" v-if="row.flag"></el-input>
              <span v-else>{{ row.classificationName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="updatedDate" label="更新时间" width="160" align="center"></el-table-column>
          <el-table-column prop="updatedBy" label="更新人" width="100" align="center"></el-table-column>
          <el-table-column label="操作" width="100" align="center">
            <template slot-scope="{ row, $index }">
              <el-button type="text" @click="row.flag = true" style="color: #409eff" v-if="!row.flag">编辑</el-button>
              <el-button type="text" @click="confirmRow(row)" v-if="row.flag">确认</el-button>
              <el-button type="text" @click="cancelRow(row, $index)" v-if="row.flag">取消</el-button>
              <el-button type="text" @click="del(row)" style="color: red" v-if="!row.flag">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </q-dialog>
  </div>
</template>

<script>
import axios from '@/utils/axiosInstance';
export default {
  name: 'storeClearance',
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '限售分类配置';
    },
  },
  data() {
    return {
      loading: false,
      tableData: {},
      imgFormVisible: false,
      addForm: {},
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 999,
        total: 0,
      },
    };
  },
  methods: {
    init() {
      this.loading = true;
      let data = { ...this.currencyForm };
      data.reportCode = 'newProductShootingCommissionModifyHis';
      data.pageNum = this.tableData.pageNum;
      data.pageSize = this.tableData.pageSize;
      this.$q.dataImport
        .getConfigInfoPage({ data: data })
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
            this.tableData.records = this.tableData.records.map((v) => {
              return {
                ...v,
                flag: false,
                isAdd: false,
              };
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    onCancel() {
      this.isVisible = false;
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },
    add() {
      this.tableData.records.push({
        classificationName: '',
        updatedDate: '',
        updatedBy: '',
        flag: true,
        isAdd: true,
      });
      this.$nextTick((_) => {
        const table = this.$refs.myTable.$el.querySelector('.el-table__body-wrapper');
        const contentHeight = table.scrollHeight;
        const containerHeight = table.clientHeight;
        table.scrollTop = contentHeight - containerHeight;
      });
    },
    confirmRow(row) {
      this.loading = true;
      let text = row.id ? '新增' : '编辑';
      this.$q.dataImport
        .saveOrUpdateRestrictedConfig({ data: row })
        .then((res) => {
          if (res.success) {
            this.$message.success(`${text}成功`);
          } else {
            this.$message.error(res.message);
          }
        })
        .finally((res) => {
          this.init();
        });
    },
    cancelRow(row, index) {
      this.init()
    },
    async del(row) {
      let status = await this.$confirm('是否确认删除该条数据？', '提示', { type: 'warning' });
      if (status !== 'confirm') return;
      let res = await this.$q.dataImport.restrictedDel({ fragment: [row.id] });
      if (res.success) {
        this.$message.success('删除成功');
      } else {
        this.$message.fail('删除失败');
      }
      this.init();
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.content {
  // max-height: 60vh;
  // overflow-y: auto;
}

.header-right {
  text-align: right;
  margin-bottom: 10px;
}

.form-input {
  width: 200px;
}

.input-number {
  >>> .el-input__inner {
    text-align: left;
  }
}

>>> .el-form .el-form-item {
  margin-bottom: 22px;
}
</style>
